<h2>TI INCURIOSISCE?</h2>
<p>Ti incuriosisce l'ambito crittografico? Pensi che la crittografia possa interessarti
	ma non hai nessuna formazione specifica? Nessun problema, abbiamo pensato anche a te!
	Ci sono infatti iniziative di carattere divulgativo che si prefiggono lo scopo di diffondere
	la crittografia al di fuori dell'ambiente universitario e aziendale. Potrebbe essere una buona
	occasione per conoscere questa materia affascinante.
</p>
<p>Consulta la pagina dedicata alle <a routerLink="/iniziative-divulgative">iniziative divulgative</a> e scopri quella
	che più
	fa al caso tuo.
</p>